import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { Co2DeliveriesComponent } from './components/co2-deliveries/co2-deliveries.component';
import { Co2ExampleCompanyComponent } from './components/co2-example-company/co2-example-company.component';
import { SustainabilityComponent } from './components/sustainability/sustainability.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SustainabilityComponent,
    Co2DeliveriesComponent,
    Co2ExampleCompanyComponent,
  ],
})
export class SustainabilityModule {}
